// frontend/src/components/VehicleCard.jsx
import { Link } from 'react-router-dom'
import defaultLogo from '../assets/logos/default.PNG'  // ajuste pra extensão correta!
import './VehicleCard.css'
import { formatCurrency, formatPercent } from '../utils/format';

// require todas as imagens .png (maiúsculas ou minúsculas) de src/assets/logos
const logoContext = require.context(
  '../assets/logos',
  false,
  /\.png$/i
)

const logoMap = logoContext.keys().reduce((map, file) => {
  // file vem como "./audi.png" ou "./BMW.PNG"
  const name = file
    .replace(/^.\//, '')          // tira "./"
    .replace(/\.(png)$/i, '')     // tira extensão
    .toLowerCase()                // tudo em lowercase
  map[name] = logoContext(file)
  return map
}, {})

export default function VehicleCard({ vehicle }) {
  // 1) colleciona o array de fotos
  const photos = Array.isArray(vehicle.photos) ? vehicle.photos : [];

  // 2) encontra a capa ou pega a primeira foto
  const cover = photos.find(p => p.isCover);
  const chosen = cover || photos[0];

  // importa o env
const rawBase = process.env.REACT_APP_API_URL || '';
// remove o sufixo "/api" para ficar só a base
const API_BASE = rawBase.replace(/\/api$/, '');

const imageUrl = photos.length > 0
  ? `${API_BASE}/uploads/${chosen.filename}`
  : '/uploads/semfoto.jpg';

const inventoryType = (vehicle.inventoryType || '').toLowerCase();
const inventoryLabel = inventoryType === 'estoque'
  ? 'Estoque Connect'
  : inventoryType === 'locadora'
    ? 'Locadora parceira'
    : 'Disponivel';

  // busca logo pela marca (lowercase); se não achar, usa default
  const brandKey = vehicle.brand.trim().toLowerCase()
  const logoSrc = logoMap[brandKey] || defaultLogo

  const price = Number(vehicle.price);
  const hasPrice = Number.isFinite(price);

  const fipeValue = Number(vehicle.fipePrice);
  const hasFipePrice = Number.isFinite(fipeValue) && fipeValue > 0 && hasPrice;

  const diff = hasFipePrice ? price - fipeValue : null;
  const diffAbs = diff !== null ? Math.abs(diff) : null;
  const percent = diffAbs !== null && fipeValue > 0 ? (diffAbs / fipeValue) * 100 : null;

  let fipeMessage = null;
  if (hasFipePrice && percent !== null) {
    if (diff < 0) {
      fipeMessage = {
        className: 'vehicle-card__fipe-diff vehicle-card__fipe-diff--positive',
        text: `Economia de ${formatPercent(percent)} (${formatCurrency(diffAbs)})`,
      };
    } else if (diff > 0) {
      fipeMessage = {
        className: 'vehicle-card__fipe-diff vehicle-card__fipe-diff--negative',
        text: `Acima da FIPE ${formatPercent(percent)} (${formatCurrency(diffAbs)})`,
      };
    } else {
      fipeMessage = {
        className: 'vehicle-card__fipe-diff vehicle-card__fipe-diff--neutral',
        text: 'Valor alinhado a FIPE',
      };
    }
  }

  return (
    <div className="vehicle-card">
      {/* logo da montadora */}
      <div className="vehicle-card__logo-wrapper">
        <img
          src={logoSrc}
          alt={vehicle.brand}
          className="vehicle-card__brand-logo"
        />
      </div>

      {/* imagem do carro */}
      <div className="vehicle-card__image-wrapper">
        <img
          src={imageUrl}
          alt={`${vehicle.brand} ${vehicle.model}`}
          className="vehicle-card__image"
        />
      </div>

      {/* corpo do card */}
      <div className="vehicle-card__body">
        <span className={`vehicle-card__tag vehicle-card__tag--${inventoryType || 'default'}`}>{inventoryLabel}</span>
        <span className="vehicle-card__brand">
          {vehicle.brand.toUpperCase()}
        </span>
        <h4 className="vehicle-card__title">
          {vehicle.model} {vehicle.version}
        </h4>

        <div className="vehicle-card__specs">
          <span className="vehicle-card__spec">
            {Number.isFinite(Number(vehicle.km)) ? Number(vehicle.km).toLocaleString('pt-BR') + ' km' : 'KM sob consulta'}
          </span>
          <span className="vehicle-card__spec">{vehicle.year}</span>
          <span className="vehicle-card__spec">
            {vehicle.transmission}
          </span>
        </div>
          
          
        <strong className="vehicle-card__price">
          {hasPrice ? formatCurrency(price) : 'Preco sob consulta'}
        </strong>
        

        {hasFipePrice && (
          <>
            <div className="vehicle-card__fipe">
              <span className="vehicle-card__fipe-label">Tabela FIPE</span>
              <span className="vehicle-card__fipe-value">{formatCurrency(fipeValue)}</span>
            </div>
            {fipeMessage && (
              <div className={fipeMessage.className}>{fipeMessage.text}</div>
            )}
          </>
        )}

        <Link
          to={`/vehicle/${vehicle.id}`}
          className="vehicle-card__button"
        >
          Ver Detalhes
        </Link>
      </div>
    </div>
  )
}
